import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'minus-vertical', 'MinusVertical', [["path",{"d":"M12 5v14"}]]);